import React from 'react';
import PropTypes from 'prop-types';
import { submitEvent } from '@bingads-webui-universal/accessibility-helper';
import { ComparedOptions } from '../common/compared-options';

export class SpecificCompareType extends React.PureComponent {
  static defaultProps = {
    selectedOption: null,
    onChangeSelectOption: undefined,
  }

  render() {
    return (
      <ol className="specific-part specific-type-select" role="presentation">
        {ComparedOptions.map(option => (
          <li
            key={option.type}
            onClick={() => this.props.onChangeSelectOption(option.type)}
            onKeyDown={event => submitEvent(this.props.onChangeSelectOption)(event, option.type)}
            className={this.props.selectedOption.type === option.type ? 'selected' : ''}
            data-value={option.keyToExport}
            // eslint-disable-next-line jsx-a11y/no-noninteractive-element-to-interactive-role
            role="button"
            tabIndex="0"
          >
            {this.props.i18n.getString(option.textToShow)}
          </li>
        ))}
      </ol>
    );
  }
}

SpecificCompareType.propTypes = {
  onChangeSelectOption: PropTypes.func,
  selectedOption: PropTypes.shape({
    type: PropTypes.number,
    keyToExport: PropTypes.string,
    textToShow: PropTypes.string,
    textToExport: PropTypes.string,
    get: PropTypes.func,
  }),
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
};
